import React from "react";

export function PostsPage() {
    return <h1>DreamStream Posts Goes Here</h1>
}